<template>
  <div class="user-wrp-comments">
    <div class="result-bracket__title user__list-count">
      <!-- <span class="result-bracket__count" v-if="comments.length !== 0" >{{ comments.length }} </span> Yorum Bulundu ! -->

      <span class="result-bracket__count">{{ comments.length }} </span> Yorum Bulundu !

    </div>

    <empty-content :content="emptyContent" v-if="comments.length === 0"/>

    <div class="user__list-offer">
      <div class="user__list-offer__item" v-for="comment in comments" :key="comment.id">
        <div class="user__list-comment-wrp">
          <div class="user__list__dorm">
            <div class="user__list__dorm-img-wrp mycursor" v-on:click="openDorm(comment.dorm.name, comment.dorm.id)" v-if="comment.dorm.logo">
              <img :src="comment.dorm.logo" class="user__list__dorm-img" alt="">
            </div>
            <div class="user__list__dorm-wrp mycursor" v-on:click="openDorm(comment.dorm.name, comment.dorm.id)" >
              <p class="user__list__dorm-name">{{ comment.dorm.name }}</p>
              <span class="user__list__dorm-location">
                 <img class="user__list__dorm-location-svg" src="@/assets/img/pin.svg"/>
                {{ comment.dorm.district.name }}, {{ comment.dorm.city.name }}</span>
            </div>
          </div>
          <p class="user__list-date"> {{ comment.created_at }}</p>
        </div>
        <div class="user__list-comment">
          {{ comment.comment }}
<!--           <div class="user__list-link">
            <span class="comment-ico">
               <svg-icon type="icon-enter"/>
            </span>
            YORUMU GÖR
          </div> -->
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EmptyContent from '@/components/EmptyContent'
export default {
  name: 'Offers',
  components: {
    EmptyContent,
    },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Yorumlarım',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/kullanici-yonetimi/yorumlarim' }
      ] 
    }
  },     
  data () {
    return {
      errors: [],
      comments: [],
      emptyContent: {
        icon: 'icon-search',
        title: 'Sonuç Bulunamadı!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },      
      comments2 : [
        {
          id: 0,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 1,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 2,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 3,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.'

        },
        {
          id: 4,
          date: '18 Mart 2018',
          logo: require('@/assets/img/campuscity-logo.png'),
          name: 'Academia Seyrantepe Kız Öğrenci Yurdu',
          location: 'Kartal, İstanbul',
          text: 'Aşağıda, devlet ve vakıf üniversitelerine ait güncel 2018-2019 Güz Dönemi Yüksek Lisans ve Doktora İlanlarına ulaşabilirsiniz. Başvuru yapacak lisansüstü öğrenim adayları bağlantılara tıklayarak ilgili ilanlara ulaşabilir ve detaylı bilgi edinebilirler. Başvuru yapmadan önce ilanlarda belirtilen koşulları sağladığınızdan ve evrakları eksiksiz olarak.' +
              ''

        }
      ]
    }
  },
  methods: {
    openDorm (name, id) {
      window.localStorage.setItem('dormid', id)
      let slug = this.string_to_slug(name)
      window.open(window.location.origin + '/' + slug + '-y-' + id, '_blank')
    },
    string_to_slug (str) {
        str = str.replace('Yurtları', 'Yurtlari')
        str = str.replace('Öğrenci', 'Ogrenci')
        str = str.replace('Kız ', 'Kiz ')       
        str = str.replace('ş', 's')
        str = str.replace('Ş', 'S')
        str = str.replace('ı', 'i')
        str = str.replace('I', 'i')
        str = str.replace('Ğ', 'G')
        str = str.replace('ğ', 'g')
        str = str.replace('Ü', 'U')
        str = str.replace('ü', 'u')
        str = str.replace('ö', 'o')
        str = str.replace('Ö', 'O')

        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },    
    getComments () {
      let self = this
      axios.get(`/user/comments`)
        .then(response => {
          self.comments = response.data.comments
          self.comments.forEach((item) => {
            const str = item.created_at.split(':')
            item.created_at = str[0] + ':' + str[1]
      })
        })
        .catch(e => {
          self.errors.push(e)
        })
    },    
  },
  mounted () {
    this.getComments()
  },    
}
</script>

<style lang="scss">
  @import "../assets/scss/components/comments";
    .mycursor { 
    cursor: pointer; }
</style>
